<template>
  <el-container v-if="!data.resizing">
    <el-header class="system_header">
      <div class="logo_container">
        <!-- <img src="../assets/logo1.png" alt="" /> -->
        <p>环保信用评价管理平台</p>
      </div>
      <div class="user">
        <!-- <el-icon class="search_icon">
          <Search />
        </el-icon>
        <input class="search_input" type="text" placeholder="请输入搜索内容" />

        <el-icon class="user_icons">
          <ChatSquare />
        </el-icon> -->
        <span style="margin-right: 1rem">{{ data.userName }}</span>
        <el-icon class="user_icons" @click="toggleUserMenu">
          <User />
        </el-icon>
        <div class="userMenu" v-if="data.userMenuVisible">
          <ul>
            <li @click="showLogOut">退出登录</li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-container class="system_navi_content_container">
      <el-aside class="system_navi" v-if="data.menuVisible">
        <el-menu
          active-text-color="white"
          background-color="transparent"
          default-active="2"
          text-color="#fff"
          @open="naviOpen"
          @close="naviClose"
          router
        >
          <!-- <div @click="toggleMenu" class="menuFold">
            <el-icon style="text-align: center; width: 100%">
              <component is="arrow-left-bold"></component>
            </el-icon>
          </div> -->
          <template v-for="item in data.userMenu" v-if="data.userMenu">
            <el-menu-item v-if="!item.children.length" :index="item.path">
              <el-icon>
                <component :is="item.iconPic"></component>
              </el-icon>
              <span>{{ item.name }}</span>
            </el-menu-item>
            <el-sub-menu v-else :index="item.path">
              <template #title>
                <el-icon> <component :is="item.iconPic"></component> </el-icon
                >{{ item.name }}</template
              >
              <el-menu-item
                v-for="item in item.children"
                :index="item.path"
                style='height:2em'
              >
                <!-- <el-icon>
                  <component :is="item.iconPic"></component>
                </el-icon> -->
                <span style="font-size: 12px;padding-left:1em">{{ item.name }}</span>
              </el-menu-item>
            </el-sub-menu>
          </template>
        </el-menu>
      </el-aside>
      <el-button
        class="menuUnFold"
        type="primary"
        icon="arrow-right-bold"
        circle
        size="large"
        v-else
        @click="toggleMenu"
      />
      <el-scrollbar class="system_content">
        <router-view></router-view>
      </el-scrollbar>
    </el-container>
  </el-container>
  <el-dialog
    v-model="data.logOutVisible"
    title="退出登录"
    width="30%"
    :before-close="hideLogOut"
  >
    <span>确认退出吗？</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="hideLogOut">取消</el-button>
        <el-button type="primary" @click="logOut">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { computed, nextTick, onBeforeUnmount, reactive } from "vue-demi";
import { useStore } from "vuex";
import _ from "lodash";
export default {
  setup() {
    const store = useStore();
    const data = reactive({
      userMenuVisible: false,
      menuVisible: true,
      resizing: false,

      userMenu: computed(() => {
        console.info('user menu',store.state.user.userMenu)
        if(store.state.user.userMenu.length){
          return store.state.user.userMenu[0].children
        }else{
          return []
        }
       
      }),
      userName: computed(() => {
        return store.state.user.userInfo.nickName || " ";
      }),
    });
    const resizeTrigger = () => {
      // window.location.reload();
      data.resizing = true;
      nextTick(() => {
        data.resizing = false;
      });
    };

    window.addEventListener("resize", _.debounce(resizeTrigger, 500));

    onBeforeUnmount(() => {
      window.removeEventListener("resize", _.debounce(resizeTrigger, 500));
    });
    return {
      data,
    };
  },
  methods: {
    naviOpen(key, keyPath) {},
    naviClose(key, keyPath) {},
    toggleUserMenu() {
      this.data.userMenuVisible = !this.data.userMenuVisible;
    },
    toggleMenu() {
      console.info("menu visible", this.data.menuVisible);
      this.data.menuVisible = !this.data.menuVisible;
      console.info("menu visible after", this.data.menuVisible);
    },
    showLogOut() {
      this.data.logOutVisible = true;
    },
    hideLogOut() {
      this.data.logOutVisible = false;
    },
    logOut() {
      sessionStorage.removeItem("cdenv_token");
      this.$store.commit("user/setUserInfo", "");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="sass" scoped>
@use "../assets/scss/system.scss" as *
</style>